import React from "react";
import ImageWithFallback from "./image-with-fallback";
import ImageError from "./image-error";

export const PDPImage = React.forwardRef((props, ref) => {
  const { className, src, mobileSrc, ...rest } = props;

  return (
    <ImageWithFallback
      ref={ref}
      fallbackElement={
        <ImageError
          className={className}
          brokenImageUrl={src || mobileSrc}
          errorText="Failed to load image"
          {...rest}
        />
      }
      width="1800"
      height="2160"
      {...props}
    />
  );
});

PDPImage.displayName = "PDPImage";

export default PDPImage;
